var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFeature1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 .667C11.12.667.667 11.12.667 24 .667 36.88 11.12 47.333 24 47.333c12.88 0 23.333-10.453 23.333-23.333C47.333 11.12 36.88.667 24 .667zm0 42C13.71 42.667 5.333 34.29 5.333 24 5.333 13.71 13.71 5.333 24 5.333c10.29 0 18.667 8.377 18.667 18.667 0 10.29-8.377 18.667-18.667 18.667z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.475 22.552c1.003-2.847.397-6.16-1.89-8.447-2.59-2.59-6.51-3.033-9.567-1.377l5.484 5.484-3.29 3.29-5.483-5.484c-1.657 3.08-1.214 6.977 1.376 9.567 2.287 2.287 5.6 2.893 8.447 1.89l7.957 7.957c.466.466 1.19.466 1.656 0l3.267-3.267a1.155 1.155 0 000-1.657l-7.957-7.956z",
    fill: "#fff"
  })));
}
export default SvgHomeFeature1;